import { FileText, Pencil, Trash2, UserPlus } from 'lucide-react'

export function CustomerActions({
  customer,
  onCreateLead,
  onCreateQuotation,
  onEdit,
  onDelete,
}) {
  return (
    <div className="flex items-center gap-1.5">
      {/* Create Lead */}
      <button
        type="button"
        onClick={() => onCreateLead?.(customer)}
        title="Create Lead from Customer"
        className="flex size-8 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-700 transition-colors hover:bg-blue-600 hover:text-white"
      >
        <UserPlus className="size-4" />
      </button>

      {/* Create Quotation */}
      <button
        type="button"
        onClick={() => onCreateQuotation?.(customer)}
        title="Create Quotation for Customer"
        className="flex size-8 items-center justify-center rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 transition-colors hover:bg-emerald-600 hover:text-white"
      >
        <FileText className="size-4" />
      </button>

      {/* Edit Customer */}
      <button
        type="button"
        onClick={() => onEdit?.(customer)}
        title="Edit Customer"
        className="flex size-8 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-700 transition-colors hover:bg-slate-800 hover:text-white"
      >
        <Pencil className="size-3.5" />
      </button>

      {/* Delete Customer */}
      <button
        type="button"
        onClick={() => onDelete?.(customer)}
        title="Delete Customer"
        className="flex size-8 items-center justify-center rounded-full border border-red-200 bg-red-50 text-red-600 transition-colors hover:bg-red-600 hover:text-white"
      >
        <Trash2 className="size-3.5" />
      </button>
    </div>
  )
}
